module.exports = __webpack_public_path__ + "static/gazele_2020-d257abd5dcabc84e94e51c0a1f4bd3e0.png";